var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4 col-md-2 text-muted text-right prevent-select"},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"col-8 col-md-10"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }